export enum BannerType {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
